<template>
  <div v-if="value !== null" class="flex items-center">
    <span class="relative flex h-2 w-2 ml-0.5">
      <span
        v-if="isOnline"
        class="animate-ping absolute inline-flex rounded-full opacity-75 h-2 w-2 bg-green"
      />
      <span
        class="relative inline-flex rounded-full h-2 w-2"
        :class="{'bg-green': isOnline, 'bg-grey-500': !isOnline}"
      />
    </span>
    <div
      class="mr-1 ml-1.5 text-xs leading-4 font-semibold items-center"
      :class="{'text-green': isOnline, 'text-grey-600': !isOnline}"
    >
      {{ text }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      required: false,
    },
  },
  computed: {
    isOnline() {
      return this.value < 15;
    },
    isNotAvailable() {
      return this.value >= 12 * 60;
    },
    text() {
      if (this.isOnline) {
        return 'Online now';
      }
      if (this.value < 60) {
        return `Active ${this.value} minutes ago`;
      }
      if (!this.isNotAvailable) {
        const text = `Active ${Math.floor(this.value / 60)}h`;
        if (this.value % 60) {
          return `${text} ${Math.floor(this.value % 60)} min ago`;
        }
        return `${text} ago`;
      }
      return '';
    },
  },
};
</script>
